import { Navigate, type RouteObject } from "react-router-dom";
import AdminRoute from "@/routes/AdminRoute.tsx";
import { SettingsLayout } from "@/features/settings/index.tsx";
import { SETTINGS_SECTIONS } from "@/features/settings/constants";

export const SettingsRoute: RouteObject[] = [
  {
    path: "settings",
    element: (
      <AdminRoute>
        <SettingsLayout />
      </AdminRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={SETTINGS_SECTIONS[0].path} replace />,
      },
      ...SETTINGS_SECTIONS,
    ],
  },
];
